import { jsx as e } from "react/jsx-runtime";
import { noop as i } from "es-toolkit/function";
import m from "../../utils/classNames.js";
import l from "../button/Button.js";
import a from "../tooltip/SimpleTooltip.js";
const g = ({ isFullscreen: t, tooltip: o, onClick: s = i }) => {
  const n = m(
    "rioglyph",
    t ? "rioglyph-resize-small" : "rioglyph-resize-full"
  ), r = /* @__PURE__ */ e(l, { bsStyle: l.MUTED, iconOnly: !0, onClick: s, "data-testid": "sidebarFullscreenToggle", children: /* @__PURE__ */ e("span", { className: n }) });
  return o ? /* @__PURE__ */ e(a, { content: o, placement: "bottom", children: r }) : r;
};
export {
  g as default
};
//# sourceMappingURL=SidebarFullscreenToggle.js.map
